import { Box } from '@chakra-ui/react';
import React from 'react';
import BGImage from '../../assets/img/RegistrationBg.png';

export const DarkBgLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      bgImage={BGImage}
      bgPosition='top center'
      bgRepeat='no-repeat'
      bgSize='100%'
      minH='100%'
      bgColor='brand.blueExtraDark'
      display='flex'
      flexDirection='column'
    >
      {children}
    </Box>
  );
};
